<template>
  <div>
    <section v-if="!companyUnderTermination">
      <b-container>
        <b-row class="mt-5">
          <b-col md="12" sm="12" lg="12" xs="12" xl="4">
            <h1 class="text-center mt-5 mb-3">Gratulálunk!</h1>
            <div
              class="d-flex justify-content-center mx-auto rounded-circle 
              bg-color-green text-white circle-box circle-box"
            >
              <div class="align-self-center">
                <transition name="fade">
                  <div v-if="showAnimatedElements">{{ totalCount }}</div>
                </transition>
              </div>
            </div>
          </b-col>
          <b-col md="12" sm="12" lg="12" xs="12" xl="8">
            <b-row class="mt-3" cols="1">
              <b-col xs="12" class="text-left offer-text text-gray-04">
                {{ totalCount }} testre szabott lehetőséget találtunk, amellyel a(z)

                <font class="text-green" v-if="selectedCompany.short_name[0]">
                  {{ selectedCompany.short_name[0].name }}
                </font>

                <font class="text-green" v-if="selectedCompany.long_name[0] && !selectedCompany.short_name[0]">
                  {{ selectedCompany.long_name[0].name }}</font
                >-t fejlesztheti!
              </b-col>
            </b-row>
            <b-row class="mt-3" id="offer-list">
              <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                <transition name="slide-fade" v-for="(dbOffer, index) in dbOffers" :key="index">
                  <div
                    class="bg-color-lightblue rounded p-4 mb-4 text-green offer-text text-left offer-badge-holder cursor-pointer"
                    v-if="showAnimatedElements && $store.getters[dbOffer.storeName]"
                    @click="nextPage()"
                  >
                    <div
                      class="d-flex justify-content-center rounded-circle bg-color-green text-white circle-mini-box float-left mr-3"
                    >
                      <div class="align-self-center">
                        {{ $store.getters[dbOffer.storeName] }}
                      </div>
                    </div>
                    {{ dbOffer.name }}
                  </div>
                </transition>
              </b-col>
              <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                <div
                  class="bg-color-lightblue rounded p-4 mb-4 text-green offer-text text-left cursor-pointer offer-badge-holder"
                  @click="nextPage()"
                  v-for="(offer, index) in constantCompanyOffers"
                  :key="index"
                >
                  <component :is="offer.componentName" class="offer-badge-svg"></component>
                  {{ offer.name }}
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <PartnerOpportunities class="mt-4 mb-5" />
      </b-container>
      <b-container>
        <login-banner :routeparam="{ companyId: this.$route.query.companyId }" />
        <p class="text-gray-04">
          A vali.hu-n megjelenő valamennyi információ, adat, feltétel, meghatározás vagy leírás kizárólag <br />
          tájékoztatásul szolgál.
        </p>
      </b-container>
    </section>
    <section v-else>
      Végelszámolás alatt levő cég!
    </section>
  </div>
</template>

<script>
import SmeClassificationInformation from '@/components/SmeClassificationInformation.vue'
import { mapGetters } from 'vuex'
import queryString from 'query-string'
import LoginBanner from '../components/LoginBanner.vue'
import CertifiedExpertsSvg from '../components/svg/CompanyOffers/CertifiedExperts'
import ModernFactoriesSvg from '../components/svg/CompanyOffers/ModernFactories'
import SchoolSvg from '../components/svg/CompanyOffers/School'
import ConsultancySvg from '../components/svg/CompanyOffers/Consultancy'
import constantCompanyOffers from '../mixins/constantCompanyOffers'
import PartnerOpportunities from './Opportunities/PartnerOpportunities.vue'

export default {
  name: 'PublicCompanyOffers',
  mixins: [constantCompanyOffers],
  components: {
    LoginBanner,
    CertifiedExpertsSvg,
    ModernFactoriesSvg,
    PartnerOpportunities,
    SchoolSvg,
    ConsultancySvg,
    SmeClassificationInformation
  },
  data() {
    return {
      selectedCompanyId: '',
      showAnimatedElements: false,
      dbOffers: [
        {
          storeName: 'creditCount',
          name: 'Támogatott hitel'
        },
        {
          storeName: 'applicationCount',
          name: 'Támogatás'
        },
        {
          storeName: 'guaranteeCount',
          name: 'Hitelgarancia'
        },
        {
          storeName: 'capitalProductCount',
          name: 'Tőkeprogram'
        }
      ]
    }
  },
  async created() {
    const { companyId } = queryString.parse(location.search)

    this.$gtag.event('company_offers_public', {
      event_category: 'user_interaction',
      companyId: companyId
    })

    if (!companyId) {
      this.$router.push('/')
    }
    this.selectedCompanyId = companyId
    const getCompanyQueryParams = { value: companyId }
    try {
      await this.$store.dispatch('getCompany', getCompanyQueryParams)
      await this.$store.dispatch('getCompetitionCounts', { companyId })
      this.showAnimatedElements = true
    } catch (err) {
      this.$router.push('/')
    }
  },
  computed: {
    ...mapGetters([
      'selectedCompany',
      'applicationCount',
      'creditCount',
      'guaranteeCount',
      'capitalProductCount',
      'totalCount',
      'companyUnderTermination',
      'isLoading'
    ])
  },
  methods: {
    nextPage() {
      this.$router.push({ path: 'register', query: { companyId: this.$route.query.companyId } })
    }
  }
}
</script>

<style scoped>
.offer-badge-holder {
  height: 85px;
}

.circle-box {
  box-shadow: 0px 0px 0px 15px var(--color-lightgreen);
  font-size: 80px;
  width: 200px;
  height: 200px;
  font-weight: bold;
  margin-top: 4.5rem;
  margin-bottom: 3rem;
}

.circle-mini-box {
  width: 50px;
  height: 50px;
  margin-top: -7px;
}

.offer-badge-svg {
  margin-right: 10px;
}

.offer-text {
  font-size: 24px;
}
</style>
